import { useParams } from "react-router-dom"
import config from "../../../config/config"
import CustomListContainer from "../../../../core/components/core/Util/List/CustomList/CustomListContainer"
import CustomList from "../../../../core/components/core/Util/List/CustomList/CustomList"
import Toast from "../../../../core/components/core/Util/Toast/Toast"
import Fetch from "../../../../core/util/core/Fetch"

function Addresses() {
  const { id } = useParams()

  const pathFrontEnd = '/gci/business-managers/'
  const pathBackEnd = config.endpoints.backend + 'gci/business-managers/'

  const paths = {
    endpoint: `${pathBackEnd}getAddressesByManagerId`,
    endpointDelete: `${pathBackEnd}deleteAddress`,
    endpointSave: `${pathBackEnd}saveAddress`,
    endpointGetById: `${pathBackEnd}getByAddressId`,

    urlGoBack: `${pathFrontEnd}list`
  }

  const labels = {
    labelTitleEdit: "Editar Endereço",
    labelTitleView: "Visualizar Endereço",
    labelTitleAdd: "Novo Endereço"
  }

  const form = {
    containerType: 'dialog',
    validateOnChange: true,
    hiddenValues: {
      manager_id: id
    },
    fields: [
      {
        label: 'Tipo',
        type: 'select',
        options: [
          {
            label: "Comercial",
            value: "COMERCIAL"
          },
          {
            label: "Residencial",
            value: "RESIDENCIAL"
          }
        ],
        name: 'type',
        validations: {
          required: true
        },
        columnSize: 12
      },
      {
        label: 'Endereço',
        type: 'address',
        name: 'address',
        validations: {
          required: true
        }
      }
    ],
    ...paths,
    ...labels
  }

  const list = {
    type: 'dialog',
    labelTitle: 'Lista de Endereços',
    handleConfirmDelete: async (item) => {
      const response = await Fetch.delete(paths.endpointDelete, { address_id: item.id, id })
      const { status } = response
      if (status === 0) {
        Toast.error('Erro ao deletar o endereço');
        return false
      }
      Toast.success('Endereço deletado com sucesso');
    },
    filter: {
      id
    },
    fieldsShowOnDelete: ['address_text'],
    columns: [
      {
        name: 'label',
        label: 'Tipo',
        width: '10%'
      },
      {
        name: 'address_text',
        label: 'Endereço',
        width: '70%'
      }
    ],
    ...paths,
    ...labels
  };

  list.form = form;

  return (
    <CustomListContainer
      labelTitle={list.labelTitle}
      labelTitleButtonAdd={list.labelTitleAdd}
      list={list}
      form={form}
      showInnerModal={true}
      content={<CustomList list={list} />}
    />
  )
}

export default Addresses
